var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuAustralia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_7453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#00008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4844 0L45.0469 8.48438L33.6562 0H30V2.90625L41.25 11.2969L30 19.6406V22.5H33.75L45 14.1094L56.2031 22.5H60V19.6875L48.7969 11.3438L60 3V0H56.4844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.125 13.1719L30 20.625V22.5L42.7031 13.1719H40.125ZM48.75 14.1094L48.4688 15.75L57.4688 22.5H60L48.75 14.1094ZM30 0V0.140625L41.6719 8.95312L41.5781 6.89062L32.3438 0H30ZM60 0L48.7969 8.25H51.6094L60 1.96875V0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7031 0V22.5H41.2031V0H48.7031ZM60 7.5V15H30V7.5H60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 9.04688V13.5469H30V9.04688H60ZM47.2031 0V22.5H42.7031V0H47.2031Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5934 37.1906L12.5152 37.4343L12.309 39.3562L13.6965 38.0062L15.0746 39.3656L14.8871 37.4437L16.809 37.2187L15.1871 36.1687L16.209 34.5281L14.3715 35.1375L13.7246 33.3093L13.059 35.1281L11.2309 34.5L12.234 36.15L10.6027 37.1906H10.5934ZM10.9402 26.2031L10.6871 24.9844L11.6059 24.1406L10.3684 24L9.85273 22.8656L9.33711 24L8.09961 24.1406L9.01836 24.9844L8.76524 26.2031L9.85273 25.5844L10.9402 26.2031ZM20.6996 20.5781L22.6027 20.7843L22.434 22.6875L23.784 21.3281L25.1715 22.65L24.9465 20.7469L26.8402 20.4937L25.2184 19.4812L26.2027 17.8406L24.3934 18.4781L23.7184 16.6875L23.0902 18.4969L21.2715 17.9062L22.2934 19.5281L20.6902 20.5781H20.6996ZM1.59336 17.5031L3.55273 17.7562L3.3371 19.7156L4.75274 18.3375L6.15899 19.725L5.96211 17.7562L7.92149 17.5312L6.26211 16.4531L7.30274 14.775L5.42774 15.4031L4.77149 13.5469L4.09649 15.4031L2.23086 14.7562L3.26211 16.4437L1.59336 17.5031ZM10.6027 9.67498L12.5434 9.8906L12.3652 11.8406L13.7434 10.4531L15.159 11.8031L14.934 9.86248L16.8746 9.59998L15.2152 8.56873L16.2184 6.8906L14.3715 7.53748L13.6871 5.70935L13.0496 7.55623L11.1934 6.94685L12.234 8.59685L10.6027 9.67498ZM38.0621 36.1594L42.3559 36.6656L41.9246 40.9687L44.9996 37.9312L48.0934 40.95L47.634 36.6469L51.9277 36.1031L48.2809 33.7781L50.5309 30.0844L46.4434 31.4906L44.9621 27.4219L43.509 31.5L39.4121 30.1218L41.6902 33.7969L38.0527 36.15L38.0621 36.1594Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_7453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuAustralia);
export default __webpack_public_path__ + "static/media/au Australia.19c817f7cd06634c362bee0591662aae.svg";
export { ForwardRef as ReactComponent };